import { React, Component } from 'react';
import { PropTypes } from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { inject, observer } from 'mobx-react';
import { css } from '@emotion/core';
import Spinner from '../common/spinner';
import CommonButton from '../common/Button';
import {
  CustomModal,
  CloseButtonContainer,
  PopUpBody,
  MessageBody,
  LogoWrapper,
  LogoWrapperInner,
} from './styled';
import IconSvg from '../common/IconSvg';
import Logo from '../Logo';

@inject('settingsStore')
@observer
class SubscriptionNotificationPopUp extends Component {
  constructor(props) {
    super(props);
    this.state = {
      enabled: true,
      hasPlan: true,
      loading: false,
    };
  }

  closePopUp = () => {
    this.setState({ enabled: false });
  };

  showUpdateMessage=(endDate)=>{
    // eslint-disable-next-line no-useless-escape
    const message=`Dear user,
    We want to remind you that your current subscription plan for 10K is set to expire on ${endDate?.split('T')[0]}. Take advantage of this opportunity to ensure uninterrupted access to our premium features and services. 
    Renew your subscription now to continue enjoying exclusive benefits and special pricing. Our team is here to assist you in selecting the best plan for your needs.
    Please contact our support team via the business WhatsApp group or support chat for personalized assistance.`;
    return message
  }
  render() {

    const {
      settingsStore: {
        subscription: { activePlan, is10kPromotionEnding, subscriptionData  },
      },
    } = this.props;

    if (this.state.hasPlan && activePlan?.allowedAddOnPlans[1]?.isSelected === false) {
      this.setState({ hasPlan: false });
    }

    return (
      <div>
        {this.state.enabled && is10kPromotionEnding ? (
          <CustomModal
            visible
            closable={false}
            width="720px"
            footer={null}
            onCancel={this.props.confirmationRequired ? null : this.closePopUp}
          >
            <CloseButtonContainer>
              <IconSvg type="x" size={10} onClick={this.closePopUp} />
            </CloseButtonContainer>
            <PopUpBody>
              <LogoWrapper>
                <LogoWrapperInner>
                  <Logo />
                </LogoWrapperInner>
              </LogoWrapper>
              <MessageBody css={css`text-align:start;padding:15px;`}>
                <div css={css`display:flex;justify-content:center;font-size:20px;font-weight:bold;`}>
                  <FormattedMessage id="subscriptionNotificationPopUp.title" />
                </div>
                <FormattedMessage id={this.showUpdateMessage(subscriptionData.expirationDate)} />
              </MessageBody>
              <CommonButton
                css={css`
                  width: 300px;
                  height: 35px;
                  font-size: 14px;
                  align-self: center;
                  display: none;
                `}
                clickHandler={this.handleClick}
              >
                <FormattedMessage id="promotionPopUp.buttonText" />
              </CommonButton>
            </PopUpBody>
          </CustomModal>
        ) : null}
        {this.state.loading && <Spinner />}
      </div>
    );
  }
}

SubscriptionNotificationPopUp.propTypes = {
  confirmationRequired: PropTypes.bool,
};

export default SubscriptionNotificationPopUp;
